/*
 * Pill or badge. `variant` picks a token pair. `bg` and `fg` props
 * override for one offs.
 */
import { styled } from '@mui/material/styles';

const VARIANTS = {
  default:  { bg: 'var(--gp-lime-soft)', fg: 'var(--gp-brand)' },
  selected: { bg: 'var(--gp-sel-bg)',    fg: 'var(--gp-sel-fg)', border: 'var(--gp-sel-border)' },
  peak:     { bg: 'var(--gp-warn-soft)', fg: 'var(--gp-warn)' },
  off:      { bg: 'var(--gp-lime-soft)', fg: 'var(--gp-brand)' },
  new:      { bg: 'var(--gp-info-soft)', fg: 'var(--gp-info)' },
  info:     { bg: 'var(--gp-info-soft)', fg: 'var(--gp-info)' },
  warn:     { bg: 'var(--gp-warn-soft)', fg: 'var(--gp-warn)' },
  danger:   { bg: 'var(--gp-danger-bg)', fg: 'var(--gp-danger-fg)', border: 'var(--gp-danger-border)' },
};

const GpPill = styled('span', {
  shouldForwardProp: (prop) => !['variant', 'bg', 'fg'].includes(prop),
})(({ variant = 'default', bg, fg }) => {
  const v = VARIANTS[variant] || VARIANTS.default;
  return {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 999,
    background: bg || v.bg,
    color: fg || v.fg,
    border: v.border ? `1px solid ${v.border}` : 'none',
    font: 'var(--gp-micro)',
    letterSpacing: 0.3,
  };
});

export default GpPill;
